import { Separator } from '@betterment/samba-react';

import { RetirementGrowthForm } from './RetirementGrowthForm';
import { RetirementGrowthTargetSheet } from './RetirementGrowthTargetSheet';

import { IdempotencyProviderWithFeatureRegistry } from '../../../../../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';
import { RetirementGrowthSettingsPurpose } from '../../../data';

type Props = {
  purpose: RetirementGrowthSettingsPurpose;
};

export const RetirementGrowthSettings = ({ purpose }: Props) => {
  return (
    <>
      <RetirementGrowthForm purpose={purpose} />
      <Separator />
      <IdempotencyProviderWithFeatureRegistry featureName="updateFinancialProfileRetirementAssumptions">
        <RetirementGrowthTargetSheet purpose={purpose} />
      </IdempotencyProviderWithFeatureRegistry>
    </>
  );
};
